export interface AddressInterface {
  countryCode?: string;
  line1?: string;
  line2?: string;
  line3?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  placeId?: string;
}

export class Address {
  countryCode: string;
  line1: string;
  line2: string;
  line3: string;
  city: string;
  state: string;
  zipCode: string;
  placeId: string;

  constructor(data: AddressInterface = {}) {
    this.countryCode = data.countryCode || '';
    this.line1 = data.line1 || '';
    this.line2 = data.line2 || '';
    this.line3 = data.line3 || '';
    this.city = data.city || '';
    this.state = data.state || '';
    this.zipCode = data.zipCode || '';
    this.placeId = data.placeId || '';
  }

  lengthWithoutCountryCode(): number {
    const singleLineLength = this.toSingleLineString().trim().length;

    if (this.countryCode) {
      return singleLineLength - this.countryCode.length;
    } else {
      return singleLineLength;
    }
  }

  toSingleLineString(): string {
    return [
      this.line1,
      this.line2,
      this.line3,
      this.city ? `${this.city},` : '',
      this.state,
      this.zipCode,
      this.countryCode
    ].filter(Boolean).join(' ');
  }

  clone(): Address {
    return new Address(this);
  }
}
